import React from 'react'
import useAppConfig from '../../../../hooks/useAppConfig'
import ContainerSectionSpecialtiesHorizontalScroll from './styles'

export default function SectionSpecialtiesHorizontalScroll() {
  const { appConfig } = useAppConfig()

  return (
    <ContainerSectionSpecialtiesHorizontalScroll>
      {appConfig?.appConfig?.specialties.specialtiesList.map(
        (specialty, _index) => {
          return (
            <div
              className={`specialties-scroll-item item-${
                _index % 2 === 0 ? 'odd' : 'even'
              }`}
              key={`key-here-specialties-scroll-${_index}`}
            >
              {specialty?.title}
            </div>
          )
        }
      )}
    </ContainerSectionSpecialtiesHorizontalScroll>
  )
}
